import { render } from "./CategorySort.vue?vue&type=template&id=90a13da2&ts=true"
import script from "./CategorySort.vue?vue&type=script&lang=ts"
export * from "./CategorySort.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__